import { memo, useEffect } from 'react'

import { modalStore } from '@core/modal'
import { sessionDialogStore } from '@core/session-dialogs'
import { useActions, useValues } from '@core/store'
import { giftStore, useGiftDialog } from '@features/donate'

export const QueuedGiftRunner = memo(() => {
    const [activeDialog, deferredSessionDialog, queuedRecipient] = useValues([
        modalStore.props.getActiveDialog,
        sessionDialogStore.props.getDeferred,
        giftStore.props.getQueuedRecipient,
    ])
    const { clearQueuedGift } = useActions({ clearQueuedGift: giftStore.actions.clearQueuedGift })
    const { open: openGiftDialog } = useGiftDialog()

    useEffect(() => {
        if (activeDialog !== null || deferredSessionDialog !== null || !queuedRecipient) {
            return
        }

        clearQueuedGift()
        openGiftDialog(queuedRecipient)
    }, [activeDialog, deferredSessionDialog, queuedRecipient, clearQueuedGift, openGiftDialog])

    return null
})
